import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent } from "@/components/ui/card";
import { DashboardLayout } from "@/components/dashboard-layout";

export const Route = createFileRoute("/_dashboard/licenses-management")({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: "Licenses Management",
    };
  },
});

function RouteComponent() {
  return (
    <DashboardLayout submenu={null}>
      <Card>
        <CardContent>
          <p className="text-md pb-20 pt-15 text-center">
            Licenses are not yet available in this client. To manage licenses, please use the legacy admin client.
          </p>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
